<template>
    <list-group-item :action="clickAction" color="primary">
        <i class="fas fa-file-invoice-dollar"></i> <strong>{{ label }}</strong>
    </list-group-item>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';
    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            ...UIComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        props: {
            openInvoices: {
                type: Number,
                required: true,
            },
        },

        emits: ['click'],

        computed: {
            label() {
                if (this.openInvoices == 1) {
                    return 'You have an open invoice';
                }
                else {
                    return 'You have '+this.openInvoices+' open invoices';
                }
            }
        },

        methods: {
            clickAction() {
                this.$emit('click');
                let homepage = this.uiStore.homePageLink;
                if (homepage == '/') {
                    homepage = '/travelers';
                }
                this.$router.push(homepage+'/accounting/invoices');
            },
        },
    }
</script>